/** 召喚コストの最終計算。全補正を足してから一度だけ0で下限処理する。 */
export function calculateSummonCost(
  baseCost: number,
  continuousModifier = 0,
  temporaryModifier = 0,
  statusReduction = 0,
): number {
  return Math.max(0, baseCost + continuousModifier + temporaryModifier - statusReduction);
}
